'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reusableLazyPromise = require('./utils/reusableLazyPromise');

var _reusableLazyPromise2 = _interopRequireDefault(_reusableLazyPromise);

var _nextTick = require('./nextTick');

var _nextTick2 = _interopRequireDefault(_nextTick);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var sleep = function sleep() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return time === 0 ? (0, _nextTick2.default)() : new _reusableLazyPromise2.default(function (res) {
    return setTimeout(res, time);
  });
};

exports.default = sleep;